import React, { memo } from 'react';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  CircularProgress,
  Box,
} from '@mui/material';
import { DialogTitleWithClose } from '../../common';
import PropTypes from 'prop-types';

const DeleteConfirmDialog = ({
  open,
  templateName,
  onClose,
  onConfirm,
  loading = false,
}) => {
  // Prevent closing dialog during deletion
  const handleClose = loading ? undefined : onClose;

  return (
    <Dialog open={open} onClose={handleClose} disableEscapeKeyDown={loading}>
      <DialogTitleWithClose
        title="Delete Template"
        onClose={handleClose}
        disableClose={loading}
      />
      <DialogContent>
        <Typography>
          Are you sure you want to delete "{templateName}"? This action cannot
          be undone.
        </Typography>
        {loading && (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mt: 2 }}>
            <CircularProgress size={20} />
            <Typography variant="body2" color="text.secondary">
              Deleting template...
            </Typography>
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          color="error"
          variant="contained"
          disabled={loading}
          startIcon={loading ? <CircularProgress size={16} /> : null}
        >
          {loading ? 'Deleting...' : 'Delete'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

DeleteConfirmDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  templateName: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

export default memo(DeleteConfirmDialog);
